import { useState } from "react";
import { devisMismatch } from "@/lib/documentAmounts";

const formatEur = (v) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(v || 0);

/** Pastille : la facture de solde ne totalise plus la même somme que son devis.
 *  Texte complet au survol (bureau) ou à l'appui (mobile). On informe, on ne propage rien. */
export const DevisMismatchWarning = ({ doc, suffix = "" }) => {
  const [open, setOpen] = useState(false);
  const ecart = devisMismatch(doc);
  if (!ecart) return null;
  const reference = ecart.devisNumber ? `du devis ${ecart.devisNumber}` : "du devis d'origine";
  const text = `Total différent ${reference} (${formatEur(ecart.docTtc)} contre ${formatEur(ecart.devisTtc)}). Le devis n'est pas modifié : vérifiez lequel des deux documents fait foi.`;
  return (
    <span className="relative inline-flex group/mismatch" data-testid={`devis-mismatch${suffix}-${doc.id}`}>
      <button
        type="button"
        aria-label={text}
        onClick={(e) => { e.stopPropagation(); setOpen(v => !v); }}
        className="h-2 w-2 rounded-full bg-amber-500 ring-2 ring-amber-100"
        data-testid={`devis-mismatch-dot${suffix}-${doc.id}`}
      />
      <span
        role="tooltip"
        className={`pointer-events-none absolute left-0 top-full z-40 mt-1 w-72 rounded-md border border-slate-200 bg-white p-2 text-[11px] font-normal leading-snug text-amber-800 shadow-xl whitespace-normal ${open ? "block" : "hidden"} md:group-hover/mismatch:block`}
        data-testid={`devis-mismatch-text${suffix}-${doc.id}`}
      >
        {text}
      </span>
    </span>
  );
};
